/** Small display formatters shared by the org/project features. */

/** `Oct 2, 2026` — the design's table/date style (§11/§12). */
export function formatDate(value?: string | number | null): string {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Human-relative TTL for a role policy spec (`TTL 12h`, `TTL 30d`, `TTL 45m`).
 * Roles have no top-level TTL, so callers pass the shortest spec TTL — the
 * lifetime the role's weakest grant actually has.
 */
export function formatTtl(ttlSeconds?: number): string {
  if (!ttlSeconds || ttlSeconds <= 0) {
    return 'TTL —';
  }
  if (ttlSeconds % 86_400 === 0) {
    return `TTL ${ttlSeconds / 86_400}d`;
  }
  if (ttlSeconds % 3_600 === 0) {
    return `TTL ${ttlSeconds / 3_600}h`;
  }
  if (ttlSeconds % 60 === 0) {
    return `TTL ${ttlSeconds / 60}m`;
  }
  return `TTL ${ttlSeconds}s`;
}

/** `2 policies` / `1 policy` — the role checklist's count label. */
export function formatPolicyCount(count: number): string {
  return `${count} ${count === 1 ? 'policy' : 'policies'}`;
}
